// extracted by css-extract-rspack-plugin
export default {"clickable":"ExtendGridCelWithSubRowsHoc_clickable__tPKtM"};